/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowConfigurationPersonalizationsQueryResponse, GetShowConfigurationPersonalizationsPathParams, GetShowConfigurationPersonalizations404 } from "../../models/GetShowConfigurationPersonalizations";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowConfigurationPersonalizationsUrl({ uuid }: { uuid: GetShowConfigurationPersonalizationsPathParams["uuid"] }) {
  const res = { method: 'GET', url: `/api/v1/configurations/${uuid}/personalizations` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid/personalizations}
 */
export async function getShowConfigurationPersonalizations({ uuid }: { uuid: GetShowConfigurationPersonalizationsPathParams["uuid"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowConfigurationPersonalizationsQueryResponse, ResponseErrorConfig<GetShowConfigurationPersonalizations404>, unknown>({ method : "GET", url : getGetShowConfigurationPersonalizationsUrl({ uuid }).url.toString(), ... requestConfig })  
  return res.data
}